module.exports = __webpack_public_path__ + "static/media/cloud-close.294645cf.png";